/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AgreementDetails,
  BulkXRITMRequest,
  BulkXRITMResponse,
  ConsentResponse,
  GetMeterPointAgreementsParams,
  GetTariffAgreementsParams,
  MeterpointXRITMParams,
  SearchMpanRequest,
  SearchMpanResponse,
  SearchMprnRequest,
  SearchMprnResponse,
  TariffAgreements,
  UpdateMeterPointConsentsRequest,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Account's Meterpoints
 */
export const getMeterpointConsents = (
  accountId: number,
  options?: SecondParameter<typeof backofficeRequest<ConsentResponse[]>>,
) => {
  return backofficeRequest<ConsentResponse[]>(
    { url: `/accounts/${accountId}/meterpoint_consents`, method: "GET" },
    options,
  )
}
/**
 * @summary Update read frequency consents for the meterpoints linked to an account (according to active agreements).
 */
export const updateMeterPointConsents = (
  accountId: number,
  updateMeterPointConsentsRequest: UpdateMeterPointConsentsRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/accounts/${accountId}/meterpoint_consents`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateMeterPointConsentsRequest,
    },
    options,
  )
}
/**
 * @summary Initiates adhoc reads for all given mpxns
 */
export const bulkXRITM = (
  bulkXRITMRequest: BulkXRITMRequest,
  options?: SecondParameter<typeof backofficeRequest<BulkXRITMResponse>>,
) => {
  return backofficeRequest<BulkXRITMResponse>(
    {
      url: `/meterpoints/bulk-xritm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkXRITMRequest,
    },
    options,
  )
}
/**
 * @summary Initiates adhoc read for given meterpoint
 */
export const meterpointXRITM = (
  params: MeterpointXRITMParams,
  options?: SecondParameter<typeof backofficeRequest<BulkXRITMResponse>>,
) => {
  return backofficeRequest<BulkXRITMResponse>(
    { url: `/meterpoints/xritm`, method: "POST", params },
    options,
  )
}
/**
 * @summary Fetch all agreement information related to meterpoint
 */
export const getMeterPointAgreements = (
  meterPointIdentifier: string,
  params: GetMeterPointAgreementsParams,
  options?: SecondParameter<typeof backofficeRequest<AgreementDetails[]>>,
) => {
  return backofficeRequest<AgreementDetails[]>(
    {
      url: `/meterpoints/${meterPointIdentifier}/agreements`,
      method: "GET",
      params,
    },
    options,
  )
}
/**
 * @summary Fetch the active agreement, current tariff and selectable tariffs for a meterpoint on an account
 */
export const getTariffAgreements = (
  meterPointIdentifier: string,
  params: GetTariffAgreementsParams,
  options?: SecondParameter<typeof backofficeRequest<TariffAgreements>>,
) => {
  return backofficeRequest<TariffAgreements>(
    {
      url: `/meterpoints/${meterPointIdentifier}/tariff-agreements`,
      method: "GET",
      params,
    },
    options,
  )
}
/**
 * Searches for a gas meterpoint (MPRN) by full postcode, partial postcode, full meter serial number, partial meter serial number or meter point identifier. Although postcode, meter serial number, and meter point identifier parameters are marked as optional, at least one of them should be supplied to the call for meaningful results.
 * @summary MPRN Lookup
 */
export const searchMprn = (
  searchMprnRequest: SearchMprnRequest,
  options?: SecondParameter<typeof backofficeRequest<SearchMprnResponse>>,
) => {
  return backofficeRequest<SearchMprnResponse>(
    {
      url: `/meterpoints/search-mprn`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchMprnRequest,
    },
    options,
  )
}
/**
 * Searches for an electricity meterpoint (MPAN) by full postcode, partial postcode, full meter serial number, partial meter serial number or meter point identifier. Although postcode, meter serial number, and meter point identifier parameters are marked as optional, at least one of them should be supplied to the call for meaningful results.
 * @summary MPAN Lookup
 */
export const searchMpan = (
  searchMpanRequest: SearchMpanRequest,
  options?: SecondParameter<typeof backofficeRequest<SearchMpanResponse>>,
) => {
  return backofficeRequest<SearchMpanResponse>(
    {
      url: `/meterpoints/search-mpan`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchMpanRequest,
    },
    options,
  )
}
export type GetMeterpointConsentsResult = NonNullable<
  Awaited<ReturnType<typeof getMeterpointConsents>>
>
export type UpdateMeterPointConsentsResult = NonNullable<
  Awaited<ReturnType<typeof updateMeterPointConsents>>
>
export type BulkXRITMResult = NonNullable<Awaited<ReturnType<typeof bulkXRITM>>>
export type MeterpointXRITMResult = NonNullable<
  Awaited<ReturnType<typeof meterpointXRITM>>
>
export type GetMeterPointAgreementsResult = NonNullable<
  Awaited<ReturnType<typeof getMeterPointAgreements>>
>
export type GetTariffAgreementsResult = NonNullable<
  Awaited<ReturnType<typeof getTariffAgreements>>
>
export type SearchMprnResult = NonNullable<
  Awaited<ReturnType<typeof searchMprn>>
>
export type SearchMpanResult = NonNullable<
  Awaited<ReturnType<typeof searchMpan>>
>
